import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { CURRICULUM_MASTER_DETAIL } from "../apiRoutes";

interface CurriculumMasterDetailResponse {
  data: any;
}

const fetchCurriculumMasterDetail = async (id: string) => {
  const response = await axiosAuth.get<CurriculumMasterDetailResponse>(
    `${CURRICULUM_MASTER_DETAIL}${id}`
  );
  return response.data;
};

const useGetCurriculumMasterDetailQuery = (
  id?: string,
  queryParams?: UseQueryOptions<any, Error, any, ["curriculumMasterDetail", string | undefined]>
) =>
  useQuery<any, Error, any, ["curriculumMasterDetail", string | undefined]>({
    queryKey: ["curriculumMasterDetail", id],
    queryFn: () => fetchCurriculumMasterDetail(String(id)),
    enabled: Boolean(id),
    ...(queryParams as any),
  });

export default useGetCurriculumMasterDetailQuery;


